import { useApolloClient } from '@apollo/client';
import { HirerTeamMemberJobAccessProvider } from '@seek/hirer-team-member-job-access';
import { useTranslations } from '@vocab/react';
import { Box, Dialog, useToast } from 'braid-design-system';
import type React from 'react';

import type { JobListItemFragment } from 'src/graphql/__generated__';

import translations from './.vocab';
import { TeamMemberAccess } from './TeamMemberAccess';

interface Props {
  seekAdvertiserId: string;
  userId: string;
  job: JobListItemFragment;
  open: boolean;
  onClose(): void;
}

export const TeamAccessDialog: React.FC<React.PropsWithChildren<Props>> = ({
  seekAdvertiserId,
  userId,
  job,
  open,
  onClose,
}: Props) => {
  const { id, title } = job;
  const client = useApolloClient();
  const showToast = useToast();
  const { t } = useTranslations(translations);

  const onUpdateSuccess = () => {
    onClose();
    showToast({
      tone: 'positive',
      message: t('Team access updated'),
    });
  };

  return (
    <Dialog
      id={`${id}-team-access`}
      title={t('Give access to your team and...')}
      open={open}
      onClose={onClose}
      width="medium"
    >
      <Box
        width="full"
        height="full"
        style={{ maxHeight: 'calc(100vh - 300px)' }}
        overflow="auto"
      >
        <HirerTeamMemberJobAccessProvider
          jobId={id}
          seekAdvertiserId={seekAdvertiserId}
          currentLoginUserId={userId}
          apolloClient={client}
        >
          <TeamMemberAccess
            onSubmitSuccess={onUpdateSuccess}
            onCancel={onClose}
            jobTitle={title}
            jobId={id}
          />
        </HirerTeamMemberJobAccessProvider>
      </Box>
    </Dialog>
  );
};
